var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.5 6.25C12.5 2.808 9.692 0 6.25 0S0 2.808 0 6.25a6.25 6.25 0 009.923 5.058L13.615 15l1.635-1.635-3.75-3.73c.635-.981 1-2.135 1-3.385zm-6.25 3.942A3.948 3.948 0 012.308 6.25 3.948 3.948 0 016.25 2.308a3.948 3.948 0 013.942 3.942 3.948 3.948 0 01-3.942 3.942z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearchIcon);
export default __webpack_public_path__ + "static/media/white-search-icon.5e2b7d1c2f950881c80c18fe0ca803f0.svg";
export { ForwardRef as ReactComponent };